import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  padding: 0 24px;
  margin-top: 36px;
`;
